<template>
  <div>
    <ul>
      <li class="nameHeading">
        <h3>{{ firstName }} {{ lastName }}</h3>
      </li>
      <router-link class="link" link :to="contactLink">
        <button class="memDetailBtn">
          <li><span class="arrow arrow-right"></span></li></button
      ></router-link>
      <div class="liClass">
        <li><b> Date Last Contacted:</b> {{ displayDateLastContact }}</li>
        <li><b>Date First Contacted:</b> {{ displayDateFirstContact }}</li>
      </div>
    </ul>
    <div class="btnContainer">
      <button class="btn memRemoveBtn" @click="remove">Remove Member</button>
      <button class="btn" @click="contactedToday">Contacted Today?</button>
    </div>
  </div>
</template>

<script>  
   import {mapActions} from 'vuex';  

    export default {
         props: ['id', 'firstName', 'spouse', 'lastName', 'houseHold', 'connectionGroup', 'connectionGroupName', 'dateFirstContact', 'dateLastContact', 'notes' ],
     
      data () {

       return {
         options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
         currentOrder: '',
      
       }
     },

      

     computed : {
      contactLink() {
         return this.$route.path + '/' + this.id
       },
      displayDateFirstContact() {
            return this.dateFirstContact.toLocaleDateString("en-us", this.options)
        },
      displayDateLastContact() {
            if(this.dateLastContact != null) {
           return this.dateLastContact.toLocaleDateString("en-us", this.options)
           } else {
              return this.dateLastContact.toLocaleDateString("en-us", this.options)
            }
        },

      
     },

     methods: {
        ...mapActions( ['removeMember']),

         async getMembers(refresh = false ) {
              this.isLoading = true
              try {
              const members = await this.$store.dispatch('members/loadMembers', {forceRefresh: refresh});
               this.isLoading = false;
               return members
              } catch (error) {
                this.error = error.message || 'Something went wrong'
              } 
              
            },

         compareDate(str1){
          // str1 format should be dd/mm/yyyy. Separator can be anything e.g. / or -. It wont effect
          var dt1   = parseInt(str1.substring(0,2));
          var mon1  = parseInt(str1.substring(3,5));
          var yr1   = parseInt(str1.substring(6,10));
          var date1 = new Date(yr1, mon1-1, dt1);
          return date1;
          },

        remove() {
          console.log('this.connectiongGroup',  this.connectionGroup)
          if(this.connectionGroup === undefined) {
            this.$emit('delete-member', this.id)
          } else {
             this.$emit('delete-member', this.id, this.connectionGroup.groupId)
          }
         
        },

        contactedToday(){
          this.$store.dispatch('members/changeLastContactedDate', {id: this.id, date: new Date()})
        },
      },
   
    }
</script>

<style scoped>
.highLight {
  border-color: red;
}

.nameHeading {
  display: flex;
}

.arrow {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-top: 2px solid #000;
  border-right: 2px solid #000;
}

.arrow-right {
  transform: rotate(45deg);
}

.liClass {
  display: flex;
  flex-direction: column;
  /* justify-content: space-evenly; */
  justify-content: left;
  text-align: left;
}

.link {
  justify-content: flex-end;
  display: flex;
  /* position: absolute; */
  /* display: flex; */
  /* float: right; */
  margin-top: -2.3rem;
}

li {
  list-style: none;
  padding: 0.05rem;
  margin-bottom: 0.3rem;
}

.btn {
  background-color: cadetblue;
  /* color: #9a3f3f; */
  color: white;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
  cursor: pointer;
}

.memDetailBtn {
  border: none;
  background-color: white;
}

.memRemoveBtn {
  background-color: #d29b9b;
}

.btnContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 1rem;
  padding: 0.2rem;
}

@media only screen and (max-width: 600px) {
  .liClass {
    margin: 0;
    display: flex;
    flex-direction: column;
  }
  ul {
    margin: 0;
    padding: 0;
  }
  .btnContainer {
    display: flex;
    border-bottom: 1px solid black;
    margin-bottom: 1rem;
    border-radius: 12px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26); */
  }
  .btn {
    width: 6rem;
    margin-bottom: 1rem;
  }
}
</style>
